const HIGHLIGHT_SEPARATOR = /[;,|\n•]+/;

// Written into a candidate's `highlights` field by the Float/Submission
// builders (see useProcessCandidateSelection) whenever the recruiter hasn't
// set any — a placeholder value, not real content, so it's never shown.
export const DEFAULT_HIGHLIGHTS =
  "Location | Salary | Availability | Best attribute";

export function parseCandidateHighlights(value?: string | null): string[] {
  if (!value || value.trim() === DEFAULT_HIGHLIGHTS) {
    return [];
  }

  return value
    .split(HIGHLIGHT_SEPARATOR)
    .map((highlight) => highlight.trim().replace(/\.$/, ""))
    .filter(Boolean);
}
